import { createApp } from "vue";
import FieldMaterials from "./FieldMaterials.vue";

const app = createApp({
  components: {
    "field-materials-component": FieldMaterials,

  },
}).mount("#container-field-materials");
